/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { ReactElement, useContext } from 'react'
import { AuthContext } from './AuthProvider'

export type RequirePermProps = {
  permissions: string[]
  render: () => ReactElement
}

/**
 * Shows component children only if user is authenticated and has permissions.
 */
function RequirePerm (props: RequirePermProps): ReactElement {
  const { permissions, render } = props
  const auth = useContext(AuthContext)
  // Check if user is authenticated or if he has permissions to access
  // component.
  return auth.signedIn && (permissions.length === 0 ||
    auth.hasPermission(...permissions))
    ? <>{render()}</>
    : <></>
}

export default RequirePerm
